type IconProps = {
  icon?: string;
  extraClass?: string;
};

const Icon = ({ icon = 'user', extraClass = '' }: IconProps) => (
  <i className={`icon icon-${icon} ${extraClass}`} aria-label={icon} />
);

export default Icon;
